import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ApiProvider from '../../../../../core/api/ApiProvider';
import { DataTableHeader } from '../../../../../core/components/Table/types/DataTableHeader';
import { DataTable } from '../../../../../core/components/Table/types/DataTable';
import { ResponseApiType } from '../../../../types/ResponseApiType';
import { Table, Loader } from '../../../../../core/components';

const CustomerTransactionPayments = () => {
  const { invoiceNo, creditorNo, accountNo, debtorNo, tenantUId } = useParams() as {
    invoiceNo: string;
    creditorNo: string;
    accountNo: string;
    debtorNo: string;
    tenantUId: string
  };
  const [tableRows, setTableRows] = useState<any[]>([]);
  const [tableHeaders, setTableHeaders] = useState<DataTableHeader[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchGetPayments = async () => {
    const resultGetPayments = await ApiProvider.post<ResponseApiType<DataTable>>(
      'CustomerTransactionPaymentsModule/GetPayments',
      {
        AccountNo: accountNo,
        CreditorNo: creditorNo,
        InvoiceNo: invoiceNo,
        DebtorNo: debtorNo,
        SourceTenantId: tenantUId
      }
    );

    if (resultGetPayments.success) {
      const headers = resultGetPayments.data.headers.map((h) => ({
        ...h,
        CssClassNames: `${!h.isVisible && 'hide-d'} ${!h.isVisibleOnMobile && 'hide-m'}`,
      }));

      setTableRows(resultGetPayments.data.dataRows);
      setTableHeaders(headers);
    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    fetchGetPayments();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Table
            headers={tableHeaders}
            rows={tableRows}
            keyField="id"
            paginationProps={{
              hideSizePerPage: true,
              hidePageListOnlyOnePage: true,
            }}
          />
        </>
      )}
    </>
  );
};

export default CustomerTransactionPayments;
